// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_8v-4";
export var collapsed = "_8v-1";
export var headerBar = "_8v-0";
export var leftHeaderContent = "_8v-3";
export var subjectContainer = "_8v-2";